import Vue from 'vue'
import Vuex from 'vuex'

import ui from './modules/ui'
import uit from './modules/uit';
import weather from './modules/weather'
import banner from './modules/banner'
import accommodation from './modules/accommodation';
import dining from './modules/dining'
import events from './modules/events'
import eventcalendar from './modules/eventcalendar'
import upcomingevent from './modules/upcomingevent'
import whatshappening from './modules/whatshappening'
import toptour from './modules/toptour'
import socialmedia from './modules/socialmedia';
import attraction from './modules/attraction';
import sightmapevent from './modules/sightmapevent'
import sightmap from './modules/sightmap'
import experience from './modules/experience'
import progress from './modules/progress'
import geolocation from './modules/geolocation';
import announcement from './modules/announcement';
import video from './modules/video';
import travelessential from './modules/travelessential';
import article from './modules/article';
import travelagency from './modules/travelagency';
import more from './modules/more';
import delegation from './modules/delegation';
import brochure from './modules/brochure';
import infocounter from './modules/infocounter';
import bordercheckpoints from './modules/bordercheckpoints';
import representative from './modules/representative';
import accessibility from './modules/accessibility';
import viedoplaylists from './modules/viedoplaylists';
import tag from './modules/tag';
import whatson from './modules/whatson';

Vue.use(Vuex);

export function createStore(previewProfile = '') {
  return new Vuex.Store({
    state: { previewProfile },
    modules: {
      ui: ui(),
      uit: uit(),
      weather: weather(),
      geolocation: geolocation(),
      banner: banner(),
      accommodation: accommodation(),
      dining: dining(),
      events: events(),
      eventcalendar: eventcalendar(),
      upcomingevent: upcomingevent(),
      whatshappening: whatshappening(),
      toptour: toptour(),
      socialmedia: socialmedia(),
      attraction: attraction(),
      sightmapevent: sightmapevent(),
      sightmap: sightmap(),
      experience: experience(),
      progress: progress(),
      announcement: announcement(),
      video: video(),
      travelessential: travelessential(),
      article: article(),
      travelagency: travelagency(),
      more: more(),
      infocounter: infocounter(),
      bordercheckpoints: bordercheckpoints(),
      delegation: delegation(),
      representative: representative(),
      brochure: brochure(),
      accessibility: accessibility(),
      viedoplaylists: viedoplaylists(),
      tag: tag(),
      whatson: whatson(),
    }
  });
}